import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Preloader from './components/ui/Preloader';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Residential from './pages/services/Residential';
import Commercial from './pages/services/Commercial';
import Industrial from './pages/services/Industrial';
import Remedies from './pages/Remedies';
import Courses from './pages/Courses';
import Blog from './pages/Blog';
import Contact from './pages/Contact';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior }); }, [pathname]);
  return null;
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <ScrollToTop />
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/residential" element={<Residential />} />
        <Route path="/services/commercial" element={<Commercial />} />
        <Route path="/services/industrial" element={<Industrial />} />
        <Route path="/remedies" element={<Remedies />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </AnimatePresence>
  );
}

export default function App() {
  const [loading, setLoading] = useState(true);
  useEffect(() => { setTimeout(() => setLoading(false), 2800); }, []);

  return (
    <BrowserRouter>
      <AnimatePresence>{loading && <Preloader key="preloader" />}</AnimatePresence>
      {!loading && (
        <>
          <Navbar />
          <AnimatedRoutes />
          <Footer />
        </>
      )}
    </BrowserRouter>
  );
}
